import React, { useState, useEffect } from 'react'
import { ReportHeading, LoaderWrapper, ReportOuterWrapper } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { CardOuterWrapper } from './style'
import RelativeBrands from './relativeBrands'
import { exportExcel_addPercentage } from '../../../../util'

const RelativeBrandsAnalysis = (props) => {
  const [graphPieData, setGraphPieData] = useState([])
  const [reportExcelData, setReportExcelData] = useState()
  const [eventCount, setEventCount] = useState(1)
  const { updateSubLhsApiLoaded } = useUpdateLhs()

  const componentType =
    props.InsightsElementType === 'SegmentOverview'
      ? 'SegmentOverview'
      : 'AllRelativeBrandsAnalysis'
  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc:
        componentType === 'SegmentOverview'
          ? ReportsService.getSegmentOverviewElement
          : ReportsService.getRelativeBrandsAnalysis,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  useEffect(() => {
    setTimeout(() => {
      setEventCount((p) => p + 1)
    }, 2000)
  }, [graphPieData])

  const onSuccessFunc = (resp) => {
    if (componentType === 'SegmentOverview') {
      // SegmentOverview
      const pieData = resp.map((d) => {
        return { name: d.SegmentName, value: d.SegmentValue }
      })
      const checkPieTotal = pieData.map((d) => d.value).reduce((a, b) => a + b, 0)
      if (checkPieTotal < 100) {
        pieData.push({ name: 'REMAINING_VALUE', value: 100 - checkPieTotal })
      }
      setGraphPieData(pieData)
      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      }, 2000)
      setReportExcelData({
        heading: ['Segment Names'],
        values: resp.map((d) => {
          return [{ value: d.SegmentName }, exportExcel_addPercentage(d.SegmentValue)]
        }),
      })
    } else {
      // AllRelativeBrandsAnalysis
      const pieData = resp.map((d) => {
        return { name: d.BrandName, value: d.BrandPercent }
      })
      setGraphPieData(pieData)
      updateSubLhsApiLoaded(props)
      setReportExcelData({
        heading: ['Brand Names'],
        values: resp.map((d) => {
          return [{ value: d.BrandName }, exportExcel_addPercentage(d.BrandPercent)]
        }),
      })
    }
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props?.type}
        {...props}
        downloadIdData={reportExcelData}
      />
      <ReportOuterWrapper>
        <CardOuterWrapper id={props.type}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <RelativeBrands
              isExtraColor={props.isExtraColor}
              graphPieData={graphPieData}
              showLegendToolTip={true}
            />
          </LoaderWrapper>
        </CardOuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default RelativeBrandsAnalysis
